import ThumbnailImage from './ThumbnailImage';

export interface BlogPostInitializer {
  publicId: number;
  name: string;
  description: string;
  jsonDescription: string;
  primaryImage: ThumbnailImage;
  publishedAt: string;
}

export default class BlogPost {
  public readonly publicId: number; // not merchant publicId but resouce publicId
  public readonly name: string;
  public readonly description: string;
  public readonly jsonDescription: string;
  public readonly primaryImage: ThumbnailImage;
  public readonly publishedAt: string;

  constructor(init: BlogPostInitializer) {
    this.publicId = init.publicId;
    this.name = init.name;
    this.description = init.description;
    this.jsonDescription = init.jsonDescription;
    this.primaryImage = init.primaryImage;
    this.publishedAt = init.publishedAt;
  }
}
